import { render } from "./TenantList.vue?vue&type=template&id=1af7a3cc&scoped=true"
import script from "./TenantList.vue?vue&type=script&lang=js"
export * from "./TenantList.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1af7a3cc"

export default script